import { api } from './axios';

export const login = (params: any) => api.post(`/api/cms/login`, params);

export const logout = () => api.post('/api/cms/logout');
